import * as actionTypes from './actionTypes';

export const onGetConsentsSuccess = response => {
    return {
        type: actionTypes.GET_CONSENTS_SUCCESS,
        response,
    };
};

export const onGetConsentsFailed = error => {
    return {
        type: actionTypes.GET_CONSENTS_FAILED,
        error,
    };
};

export const onGetConsentsStart = (clientId, productId, sessionId) => {
    return {
        type: actionTypes.GET_CONSENTS,
        clientId,
        productId,
        sessionId,
    };
};
